import CustomButton from "@components/buttons/CustomButton";
import GlobalTextInputField from "@components/inputs/GlobalTextInputField";
import SlidingPanel from "@components/sliders/SlidingPanel";
import { ipBlocklistService } from "@services/apis/IpBlocklist";
import React, { useState } from "react";
import useSnackbarMessage from "../../../utils/HandleSuccessErrorSnackbars";

interface AddIpBlocklistSliderProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

const AddIpBlocklistSlider: React.FC<AddIpBlocklistSliderProps> = ({
  isOpen,
  onClose,
  onSuccess,
}) => {
  const [ip, setIp] = useState("");
  const [reason, setReason] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { handleError, handleSuccess } = useSnackbarMessage();

  const resetForm = () => {
    setIp("");
    setReason("");
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleSubmit = async () => {
    if (!ip.trim()) {
      handleError({ message: "IP address is required" });
      return;
    }

    try {
      setIsLoading(true);
      const response = await ipBlocklistService.addIp({
        ip: ip.trim(),
        reason: reason.trim() || undefined,
      });
      handleSuccess({
        message: response.msg || "IP added to blocklist successfully",
      });
      resetForm();
      onSuccess?.();
      onClose();
    } catch (error: any) {
      handleError({
        message:
          error?.response?.data?.msg ||
          "Failed to add IP to blocklist. Please try again.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <SlidingPanel
      isOpen={isOpen}
      heading="Block IP Address"
      onClose={handleClose}
      onClickCross={handleClose}
      showConfirm={false}
    >
      <div className="flex flex-col px-[16px] py-[16px] gap-4">
        <GlobalTextInputField
          placeholder="Enter IP address (IPv4 or IPv6)"
          value={ip}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setIp(e.target.value)
          }
          title="IP Address"
        />
        <GlobalTextInputField
          placeholder="Optional reason for blocking"
          value={reason}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setReason(e.target.value)
          }
          title="Reason (Optional)"
        />
        <CustomButton
          text="BLOCK IP"
          onClick={handleSubmit}
          isActive={!!ip.trim()}
          isButtonLoading={isLoading}
        />
      </div>
    </SlidingPanel>
  );
};

export default AddIpBlocklistSlider;
